module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpY29uLXBvcHVsYXRpb24tYzMzYzEzM2YwZmI2YTE4MzZhMTk1NWZkMjdiNjVhODAuc3ZnIjs="


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/icon-population.svg
// module id = 574
// module chunks = 0